
/**
 * 描述：辅助编辑 主题延展指令
 * 日期：2017-10-18
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('topicExtensionModule', []).directive('scTopicExtension', ['alterModule', '$timeout', 'trsHttpService', 'loginService', '$q', function(alterModule, $timeout, trsHttpService, loginService, $q) {
    return {
        replace: true,
        restrict: 'E',
        transclude: false,
        scope: false,
        templateUrl: './editingCenter/directive/supportCreation/topicExtension/topicExtension_tpl.html',
        link: function(scope, $elem, $attrs) {
            var ue = UE.getEditor('ueditor');
            var content;
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                var status = {
                    indexname: '',
                    canSend: true,
                    waitSend: false,
                };
                var page = {
                    subject: {
                        CURRPAGE: 1,
                        PAGESIZE: 5,
                        PAGECOUNT: '',
                    },
                };
                var message = {
                    subjectHasNoMore: true,
                    notShowMore: true,
                };
                var data = {
                    items: [],
                    categoryArray: [
                        {
                            name: '全网资源',
                            value: 'internet',
                        }, {
                            name: '成品资源',
                            value: 'product',
                        },
                    ],
                    channelArray: [
                        {
                            name: '全部',
                            value: '全部',
                        }, {
                            name: '微信',
                            value: '微信',
                        },
                        {
                            name: '微博',
                            value: '微博',
                        }, {
                            name: '网站',
                            value: '网站',
                        },
                        {
                            name: 'APP',
                            value: 'APP',
                        },
                    ],
                    areaArray: [
                        {
                            name: '全部',
                            value: '001',
                        }, {
                            name: '央媒',
                            value: '001000',
                        }, 
                        // {
                        //     name: '疆内',
                        //     value: '001015',
                        // },
                    ],
                    searchCondition: {
                        category: 'internet',
                        channel: '全部',
                        mediaAreaCode: '001',
                    },
                };
                angular.extend(scope.status, status);
                angular.extend(scope.status.page, page);
                angular.extend(scope.status.message, message);
                angular.extend(scope.data, data);
                scope.noWidth = true;
                ue.addListener('contentChange', function() { // 实时双向绑定开始
                    content = ue.getContentTxt();
                    var localContent = localStorage.getItem('contentTxt') ? localStorage.getItem('contentTxt') : ' ';
                    localStorage.setItem('contentTxt', content);
                    // 若纯文本内容不变，无需触发
                    if (localContent == content) {
                        return false;
                    }
                    resetSearchCondition();
                    scope.data.items = [];
                    updateDate(content);
                });
            }

            /**
             * [updateDate description]更新数据
             * @param   {[type]}  content  [content description]
             * @return  {[type]}           [return description]
             */
            function updateDate(content) {
                var content_ = content.replace(/\n/g, '');
                if (content_ !== '' && content_.length > 20) {
                    if (scope.status.canSend){
                        scope.status.canSend = false;
                        querySubject(false);
                        $timeout(() => {
                            scope.status.canSend = true;
                        }, 3000);
                    } else {
                        if (!scope.status.waitSend){
                            scope.status.waitSend = true;
                            $timeout(() => {
                                updateDate();
                                scope.status.waitSend = false;
                            }, 5000);
                        }
                    }
                } else {
                    scope.data.items = [];
                    scope.status.message.subjectHasNoMore = true;
                    scope.loadingPromise = {
                        $$state: {
                            status: 1
                        }
                    };
                }
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                content = ue.getContentTxt();
                getCurrUserInfo();
                updateDate(content);
            }

            /**
             * [updateSelectedItems description：打开新窗口]
             * @param  {[type]} item      [description：被点击的对象]
             * @param  {[type]} indexname      [description：当前对象名称（因为在不同的表，所以单独处理）]
             * @return {[type]} [description]
             */
            scope.windowOpen = function(item, indexname) {
                alterModule.alterDeatil(item, indexname);
            };
            scope.createDate = function(_sDate) {
                return new Date(_sDate);
            };
            // 加载更多主题背景
            scope.getMoreSub = function() {
                if (scope.status.page.subject.CURRPAGE >= scope.status.page.subject.PAGECOUNT) {
                    return;
                }
                scope.status.page.subject.CURRPAGE += 1;
                querySubject(true);
            };

            /**
             * [getLocationList description]根据当前登录人的信息 获取token，获取其他地区
             * @return  {[type]}  [return description]
             */
            function getCurrUserInfo() {
                loginService.getCurrLoginUser().then(function(user) {
                    scope.data.tenantId = user.TENANTID;
                });
            }

            /**
             * [querySubject description:查询主题延展]
             * @param  {Boolean} isGetMore [description：判断是否加载跟多]
             * @return {[type]} [description]
             */
            function querySubject(isGetMore) {
                if (scope.loadingPromise) {
                    $timeout.cancel(scope.loadingPromise);
                }
                var defer = $q.defer();
                scope.loadingPromise = $timeout(function() {
                    var params = {
                        typeid: 'zyzx',
                        serviceid: 'write',
                        modelid: 'subjectExtension',
                        content: content,
                        pageSize: scope.status.page.subject.PAGESIZE,
                        pageNum: scope.status.page.subject.CURRPAGE,
                        tenantId: scope.data.tenantId,
                    };
                    angular.extend(params, scope.data.searchCondition);
                    scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                        if (data.result === 'fail' || data === '' || data.result === 'warn') {
                            if (isGetMore) {
                                scope.loadMoreFalse = true;
                                $timeout(function() {
                                    scope.loadMoreFalse = false;
                                }, 1500);
                            }
                            defer.resolve();
                            return;
                        }
                        if (isGetMore) {
                            scope.data.items = scope.data.items.concat(data.content);
                        } else {
                            scope.data.items = data.content;
                        }

                        scope.status.indexname = data.summary_info.indexName;
                        scope.status.page.subject = data.summary_info;
                        defer.resolve();
                    });
                }, 800);
                return defer.promise;
            }

            /**
             * [searchByCondition description] 搜索条件函数
             * @param   {[type]}  key  [value description] 需要赋值对象的key
             * @param   {[type]}  value   [key description] 取值对象的key
             * @param   {[type]}  item   [item description] 取值对象
             * @return  {[type]}         [return description]
             */
            scope.searchByCondition = function(key, value, item) {
                scope.status.page.subject.CURRPAGE = 1;
                // scope.data.isshowLocation = false;
                if (key) {
                    scope.data.searchCondition[key] = item[value];
                    if (key === 'category') {
                        resetSearchCondition();
                    }
                } else {
                    resetSearchCondition();
                }
                scope.data.items = [];
                querySubject();
            };

            scope.selectedLocation = function(item) {
                scope.searchByCondition('mediaAreaCode', 'dictnum', item);
            };

            /**
             * [clickToRetry description] 点击重试
             * @return  {[type]}  [return description]
             */
            scope.pageChanged = function() {
                querySubject();
            }; 

            /**
             * [resetSearchCondition description] 重置搜索条件，只重置地域和渠道
             * @return  {[type]}  [return description]
             */
            function resetSearchCondition() {
                scope.data.searchCondition.channel = '全部';
                scope.data.searchCondition.mediaAreaCode = '001';
            }
        },
    };
},]);
